module.exports = __webpack_public_path__ + "04_2x.jpg?68793b08857426f4347b1e9555dadc8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/04_2x.jpg
// module id = 15
// module chunks = 0